import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRadioGroup,_vm._g(_vm._b({attrs:{"row":_vm.row,"label":_vm.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-radio-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.items),function(option){return _c(VRadio,{key:option.id,attrs:{"label":option.label,"value":option.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }